import styled from 'styled-components';

import ChevronDownIcon from '../../assets/images/icons/chevron-down.svg';
import ChevronRightIcon from '../../assets/images/icons/chevron-right.svg';

export const ChevronDown = styled.img.attrs({ src: ChevronDownIcon, alt: '', 'aria-hidden': 'true' })`
  width: 16px;
  height: 16px;
`;

export const ChevronRight = styled.img.attrs({ src: ChevronRightIcon, alt: '', 'aria-hidden': 'true' })`
  width: 7px;
  height: 11px;
  margin-left: 8px;
`;
